import request from '@/utils/request'


// 查询国家地区信息 (来源于掌榕)列表
export function listCountry(query) {
  return request({
    url: '/biz/admin/extra/country/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询国家地区信息 (来源于掌榕)分页
export function pageCountry(query) {
  return request({
    url: '/biz/admin/extra/country/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
